import React from "react";
import { ToggleButtonGroup, ToggleButton, Typography } from "@mui/material";
import "./PulseSelectButton.scss";

export interface PulseSelectButtonOption {
  label: string;
  value: string;
  description?: string;
  icon?: React.ReactNode;
}

interface PulseSelectButtonProps {
  options: PulseSelectButtonOption[];
  value: string;
  onChange: (value: string) => void;
  variant?: "default" | "platform";
}

const PulseSelectButton: React.FC<PulseSelectButtonProps> = ({
  options,
  value,
  onChange,
  variant = "default",
}) => {
  return (
    <div
      className={`pulse-select-button ${variant === "platform" ? "platform-variant" : ""}`}
    >
      <ToggleButtonGroup
        value={value}
        exclusive
        onChange={(_, newValue) => {
          if (newValue !== null) {
            onChange(newValue);
          }
        }}
        className="toggle-group"
        fullWidth
      >
        {options.map((option) => (
          <ToggleButton
            key={option.value}
            value={option.value}
            className={`select-button ${value === option.value ? "selected" : ""}`}
          >
            <div className="select-button-content">
              {option.icon && (
                <div className="select-button-icon">{option.icon}</div>
              )}
              <Typography className="select-button-label" variant="subtitle1">
                {option.label}
              </Typography>
              {option.description && (
                <Typography
                  className="select-button-description"
                  variant="body2"
                >
                  {option.description}
                </Typography>
              )}
            </div>
          </ToggleButton>
        ))}
      </ToggleButtonGroup>
    </div>
  );
};

export default PulseSelectButton;
